/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const PersonTitle = {
  None: 'NONE',
  Dr: 'DR',
  DrMed: 'DR_MED',
  Prof: 'PROF',
  ProfMed: 'PROF_MED',
} as const;
export type PersonTitle = (typeof PersonTitle)[keyof typeof PersonTitle];
